import {ReactComponent as RoomIcon} from '../assets/icons/Room.svg'
import {ReactComponent as RoomDarkIcon} from '../assets/icons/RoomDark.svg'
import {ReactComponent as WingIcon} from '../assets/icons/Wing.svg'
import {ReactComponent as UnitIcon} from '../assets/icons/Unit.svg'
import {ReactComponent as WingDarkIcon} from '../assets/icons/WingDark.svg'
import {ReactComponent as UnitDarkIcon} from '../assets/icons/UnitDark.svg'
import {ReactComponent as DependentIcon} from '../assets/icons/Dependent.svg'
import {ReactComponent as DependentReservationIcon} from '../assets/icons/DependentReservation.svg'
import {ReactComponent as ClientReservationIcon} from '../assets/icons/ClientReservation.svg'
import {ReactComponent as UnoccupiedBedIcon} from '../assets/icons/UnoccupiedBed.svg'
import {ReactComponent as AllergyIcon} from '../assets/icons/Allergy.svg'
import {ReactComponent as MedicationsIcon} from '../assets/icons/Medications.svg'

export const Room = ()=>{ return <RoomIcon/>};
export const RoomDark = ()=>{ return <RoomDarkIcon/>};
export const Wing = ()=>{ return <WingIcon/>};
export const Unit = ()=>{ return <UnitIcon/>};
export const WingDark = ()=>{ return <WingDarkIcon/>};
export const UnitDark = ()=>{ return <UnitDarkIcon/>};
export const Dependent = ()=>{return <DependentIcon/>}
export const DependentReservation = ()=>{return <DependentReservationIcon/>}
export const ClientReservation = ()=>{return <ClientReservationIcon/>}
export const UnoccupiedBed = ()=>{return <UnoccupiedBedIcon/>}
export const Allergy = ()=>{return <AllergyIcon/>}
export const Medication = ()=>{return <MedicationsIcon/>}